<!-- 进场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {

            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报欠费记录变更到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportParkingArrearRecordChange",
                precondition: "无",
                fitSystem: "智汇云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录号' },
                      { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码' },
                      { info1: 'plateColor', info2: '是', info3: 'Integer', info4: '车牌颜色：0其他，1蓝色，2黄色，3白色，4黑色，5绿色' },
                      { info1: 'arrearRealValue', info2: '是', info3: 'BigDecimal', info4: '当前欠费金额' },
                      { info1: 'payBackStatus', info2: '是', info3: 'Integer', info4: '补缴状态 1 已补缴 0 未补缴' },
                      { info1: 'backRealValue', info2: '否', info3: 'BigDecimal', info4: '补缴金额' },
                      { info1: 'payBackTime', info2: '否', info3: 'String', info4: '补缴时间，格式 yyyyMMddHHmmss' },
                      { info1: 'arrearMarkTime', info2: '是', info3: 'String', info4: '欠费标记时间 格式 yyyyMMddHHmmss' },
                      { info1: 'arrearStatus', info2: '是', info3: 'Integer', info4: '欠费状态 1正常欠费，0取消欠费' },
                      { info1: 'arrearOrigin', info2: '是', info3: 'Integer', info4: '欠费来源，0:未定义，1：同车再次进场， 2：盘点离场， 3：高峰模式， 4：常开模式， 5：线下离线放行，6：可疑跟车，7：微信无感失败，欠费放行，12：手动新增' },
                      { info1: 'enterTime', info2: '否', info3: 'String', info4: '进场时间 yyyyMMddHHmmss' },
                      { info1: 'leaveTime', info2: '否', info3: 'String', info4: '离场时间  yyyyMMddHHmmss' },
                      { info1: 'enterCarImageUrl', info2: '否', info3: 'String', info4: '进场图片' },
                      { info1: 'leaveCarImageUrl', info2: '否', info3: 'String', info4: '离场图片' },
                      { info1: 'payBackBillCode', info2: '否', info3: 'String', info4: '补缴订单号' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportParkingArrearRecordChange.vue